import z from 'zod';

import { CriterionRecord } from 'src/types';
import { zodIssuesIntoErrorsMap } from 'src/utils/validation';

export const companySubscriptionSetConfigsSchema = z.object({
  allowAllUsers: z.boolean(),
  add_company_allowed_user_id_whitelist: z.array(z.number()).nullable(),
});

export const getFormValidator = (values: Partial<CriterionRecord>) => {
  const validationResult = companySubscriptionSetConfigsSchema.safeParse(values);
  if (validationResult.success) return {};

  const errorMap = zodIssuesIntoErrorsMap(validationResult.error.issues);
  // TODO: Look into an abstraction for this (e.g. in `zodIssuesIntoErrorsMap`)
  if (Array.isArray(errorMap.add_company_allowed_user_id_whitelist)) {
    errorMap.add_company_allowed_user_id_whitelist = errorMap.add_company_allowed_user_id_whitelist[0];
  }
  return errorMap;
};
